import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../common/breadcrumbs";
import { formateDate, showStatus } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";
import * as players from "../../../services/players.service";
import * as LiveCalcApi from "../../../services/liveCalculations.service";

const ViewPlayers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const isDev = searchParams.get("dev") === "true";
  const [showdefault, setShowDefault] = useState({});
  const [matchData, setMatchData] = useState([]);
  const [assignTeam, setAssignteam] = useState([]);
  const [activeTab, setActiveTab] = useState("details");
  const [playTimeData, setPlayTimeData] = useState(null);
  const [loadingPlayTime, setLoadingPlayTime] = useState(false);
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("Player"), url: "/admin/user-management/players/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    players
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  useEffect(() => {
    players
      .Matches(params.id)
      .then((data) => {
        setMatchData(data.data.assignedMatches);
      })
      .catch((error) => {
        console.log("error fetching matches", error);
      });
  }, []);

  useEffect(() => {
    players
      .TeamManagament(params.id)
      .then((data) => {
        setAssignteam((data && data?.data && data?.data?.teams) || []);
      });
  }, []);

  useEffect(() => {
    if (isDev && activeTab === "play_time" && !playTimeData && params.id) {
      setLoadingPlayTime(true);
      const effTeam = (assignTeam && assignTeam[0]?.id) || "all";
      LiveCalcApi.getPlayerReport(effTeam, params.id)
        .then((res) => {
          setPlayTimeData(res?.data?.playTime || null);
        })
        .catch((error) => {
          console.error("Error fetching play time:", error);
        })
        .finally(() => {
          setLoadingPlayTime(false);
        });
    }
  }, [isDev, activeTab, params.id, assignTeam, playTimeData]);


  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              {/* Navigation Tabs Header - Only visible when dev=true */}
              {isDev ? (
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-4 pb-2 border-bottom">
                  <h6 className="main-content-label mb-2 mb-md-0">
                    Player View: {showdefault.firstName || ""} {showdefault.lastName || ""}
                  </h6>
                  <div className="btn-group" role="group">
                    <button
                      type="button"
                      className={`btn btn-sm ${activeTab === "details" ? "btn-primary" : "btn-outline-primary"}`}
                      onClick={() => setActiveTab("details")}
                    >
                      👤 Profile & Club
                    </button>
                    <button
                      type="button"
                      className={`btn btn-sm ${activeTab === "matches" ? "btn-primary" : "btn-outline-primary"}`}
                      onClick={() => setActiveTab("matches")}
                    >
                      🏆 Assigned Matches ({matchData?.length || 0})
                    </button>
                    <button
                      type="button"
                      className={`btn btn-sm ${activeTab === "play_time" ? "btn-primary" : "btn-outline-primary"}`}
                      onClick={() => setActiveTab("play_time")}
                    >
                      ⏱️ Play Time Breakdown
                    </button>
                  </div>
                </div>
              ) : (
                <div>
                  <h6 className="main-content-label mb-3">Player View</h6>
                </div>
              )}

              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">

                    {/* ─── TAB 1: DETAILS & CLUB ─── */}
                    {(!isDev || activeTab === "details") && (
                      <>
                        <h6 className="main-content-label mb-3">Player Details</h6>
                        <table id="simple-table" className="table table-bordered table-hover mb-4">
                          <tbody>
                            <tr>
                              <th>{t("label_name")}</th>
                              <td className="text-capitalize">
                                {showdefault.firstName || "N/A"} {showdefault.lastName || "N/A"}
                              </td>
                            </tr>
                            <tr>
                              <th>{t("label_email")}</th>
                              <td>{showdefault && showdefault?.email ? showdefault.email : "N/A"}</td>
                            </tr>
                            <tr>
                              <th>{t("label_gender")}</th>
                              <td>{showdefault && showdefault?.gender ? showdefault.gender : "N/A"}</td>
                            </tr>
                            <tr>
                              <th>{t("Dob")}</th>
                              <td>{showdefault && showdefault?.dob ? showdefault.dob : "N/A"}</td>
                            </tr>
                            <tr>
                              <th>{t("label_city")}</th>
                              <td>{showdefault && showdefault?.city ? showdefault?.city : "N/A"}</td>
                            </tr>
                            <tr>
                              <th>{t("label_country")}</th>
                              <td>{showdefault && showdefault?.country ? showdefault?.country : "N/A"}</td>
                            </tr>
                            <tr>
                              <th>{t("label_preferredpossitions")}</th>
                              <td>
                                {showdefault?.preferredPositions?.flat().join(", ") || "N/A"}
                              </td>
                            </tr>
                            <tr>
                              <th>{t("label_height")}</th>
                              <td>{showdefault && showdefault?.height ? showdefault.height : "N/A"}</td>
                            </tr>
                            <tr>
                              <th>{t("label_phone")}</th>
                              <td>{showdefault && showdefault?.phone_number ? showdefault.phone_number : "N/A"}</td>
                            </tr>
                            <tr>
                              <th>{t("list_heading_status")}</th>
                              <td>
                                {toHtml(showStatus(showdefault.status))}
                              </td>
                            </tr>
                            <tr>
                              <th>{t("list_heading_created_date")}</th>
                              <td>{formateDate(showdefault.createdAt) || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>{t("label_modified_date")}</th>
                              <td>{formateDate(showdefault.updatedAt) || "N/A"}</td>
                            </tr>
                          </tbody>
                        </table>

                        {/* Club Details */}
                        <h6 className="main-content-label mb-3">
                          {t("label_club_name_details")}
                        </h6>
                        <table className="table table-bordered table-hover">
                          <tbody>
                            {showdefault ? (
                              <>
                                <tr>
                                  <td>{t("label_name")}</td>
                                  <td>{showdefault?.clubDetails?.name || "N/A"}</td>
                                </tr>
                                <tr>
                                  <td>{t("label_club_email") || "Club Email"}</td>
                                  <td>{showdefault?.clubDetails?.email || showdefault?.clubEmail || "N/A"}</td>
                                </tr>
                                <tr>
                                  <td>{t("label_address")}</td>
                                  <td>{showdefault?.clubDetails?.address || "N/A"}</td>
                                </tr>
                                <tr>
                                  <td>{t("label_city")}</td>
                                  <td>{showdefault?.clubDetails?.city || showdefault?.city || "N/A"}</td>
                                </tr>
                                <tr>
                                  <td>{t("label_country")}</td>
                                  <td>{showdefault?.clubDetails?.country || showdefault?.country || "N/A"}</td>
                                </tr>
                                <tr>
                                  <td>{t("label_state")}</td>
                                  <td>{showdefault?.clubDetails?.state || "N/A"}</td>
                                </tr>
                                <tr>
                                  <td>{t("zip_code")}</td>
                                  <td>{showdefault?.clubDetails?.zipCode || "N/A"}</td>
                                </tr>
                              </>
                            ) : (
                              <tr>
                                <td colSpan="2" className="text-center">
                                  {t("msg_no_records")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </>
                    )}

                    {/* ─── TAB 2: ASSIGNED MATCHES ─── */}
                    {(!isDev || activeTab === "matches") && (
                      <>
                        <h6 className="main-content-label mb-3">{t("label_all_matches")}</h6>
                        <table id="simple-table" className="table table-bordered table-hover">
                          <thead>
                            <tr>
                              <th>{t("list_heading_sno")}</th>
                              <th>{t("label_match_title")}</th>
                              <th>{t("label_match_date")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {matchData && matchData.length > 0 ? (
                              matchData.map((item, index) => (
                                <tr key={index}>
                                  <td style={{ width: "80px" }}>{index + 1}</td>
                                  <td>{item?.title || "N/A"}</td>
                                  <td>{item?.date || "N/A"}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-center">
                                  {t("msg_no_records")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </>
                    )}

                    {/* ─── TAB 3: PLAY TIME BREAKDOWN & FORMULA ─── */}
                    {isDev && activeTab === "play_time" && (
                      <div className="lc-playtime-view-wrapper">
                        {/* FORMULA BANNER */}
                        <div className="card bg-light border-primary mb-4" style={{ borderRadius: "10px" }}>
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                              <h5 className="text-primary font-weight-bold mb-0">
                                ⏱️ Player Play Time & Substitution Calculation Formula
                              </h5>
                              <span className="badge badge-primary px-3 py-2" style={{ fontSize: "12px" }}>
                                Total Play Time = Σ (Interval End - Interval Start)
                              </span>
                            </div>
                            <p className="text-muted mb-3" style={{ fontSize: "13px" }}>
                              Deterministic on-court clock tracking based on starting seven court status, substitutions, and bench re-entries.
                            </p>
                            
                            <div className="row">
                              <div className="col-md-3 mb-2">
                                <div className="p-3 bg-white border rounded h-100 shadow-sm">
                                  <div className="d-flex align-items-center mb-2">
                                    <span className="badge badge-primary mr-2" style={{ width: "24px", height: "24px", borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>1</span>
                                    <strong style={{ fontSize: "13px" }}>Starting 7 Baseline</strong>
                                  </div>
                                  <p className="text-muted mb-0" style={{ fontSize: "12px", lineHeight: "1.5" }}>
                                    The 7 starting players (<code>GS, GA, WA, C, WD, GD, GK</code>) begin at <code>00:00</code>. By default, play time = full match duration (<code>Quarters × Quarter Length</code>).
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-3 mb-2">
                                <div className="p-3 bg-white border rounded h-100 shadow-sm">
                                  <div className="d-flex align-items-center mb-2">
                                    <span className="badge badge-danger mr-2" style={{ width: "24px", height: "24px", borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>2</span>
                                    <strong style={{ fontSize: "13px" }}>Substituted OUT</strong>
                                  </div>
                                  <p className="text-muted mb-0" style={{ fontSize: "12px", lineHeight: "1.5" }}>
                                    When an on-court player is replaced, active timer stops at the exact substitution timestamp <code>T_sub</code>.
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-3 mb-2">
                                <div className="p-3 bg-white border rounded h-100 shadow-sm">
                                  <div className="d-flex align-items-center mb-2">
                                    <span className="badge badge-success mr-2" style={{ width: "24px", height: "24px", borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>3</span>
                                    <strong style={{ fontSize: "13px" }}>Substituted IN</strong>
                                  </div>
                                  <p className="text-muted mb-0" style={{ fontSize: "12px", lineHeight: "1.5" }}>
                                    When a bench / impact player enters, playing timer starts from that substitution timestamp <code>T_sub</code> onward.
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-3 mb-2">
                                <div className="p-3 bg-white border rounded h-100 shadow-sm">
                                  <div className="d-flex align-items-center mb-2">
                                    <span className="badge badge-info mr-2" style={{ width: "24px", height: "24px", borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>4</span>
                                    <strong style={{ fontSize: "13px" }}>Re-Entry & Aggregation</strong>
                                  </div>
                                  <p className="text-muted mb-0" style={{ fontSize: "12px", lineHeight: "1.5" }}>
                                    If a substituted player comes back in, play timer resumes. Total play time = sum of all on-court segment intervals.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* KPI SUMMARY CARDS */}
                        {loadingPlayTime ? (
                          <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                              <span className="sr-only">Calculating Play Time...</span>
                            </div>
                            <p className="mt-2 text-muted">Calculating play time and substitution timeline...</p>
                          </div>
                        ) : (
                          <>
                            <div className="row mb-4">
                              <div className="col-lg-3 col-sm-6 mb-3">
                                <div className="card border-0 shadow-sm text-center p-3" style={{ background: "#f0fdf4", borderLeft: "4px solid #16a34a" }}>
                                  <span className="text-muted text-uppercase" style={{ fontSize: "11px", fontWeight: "700" }}>Total Play Time</span>
                                  <h3 className="font-weight-bold text-success my-1">
                                    {playTimeData?.overall?.formatted || `${playTimeData?.overall?.totalMinutes || 0}m`}
                                  </h3>
                                  <span className="text-muted" style={{ fontSize: "12px" }}>
                                    {playTimeData?.overall?.totalSeconds || 0} Total Seconds
                                  </span>
                                </div>
                              </div>
                              <div className="col-lg-3 col-sm-6 mb-3">
                                <div className="card border-0 shadow-sm text-center p-3" style={{ background: "#eff6ff", borderLeft: "4px solid #2563eb" }}>
                                  <span className="text-muted text-uppercase" style={{ fontSize: "11px", fontWeight: "700" }}>Average per Match</span>
                                  <h3 className="font-weight-bold text-primary my-1">
                                    {playTimeData?.overall?.avgMinutesPerMatch || 0} min
                                  </h3>
                                  <span className="text-muted" style={{ fontSize: "12px" }}>
                                    Across {playTimeData?.overall?.matchesCount || 0} match(es)
                                  </span>
                                </div>
                              </div>
                              <div className="col-lg-3 col-sm-6 mb-3">
                                <div className="card border-0 shadow-sm text-center p-3" style={{ background: "#fffbeb", borderLeft: "4px solid #d97706" }}>
                                  <span className="text-muted text-uppercase" style={{ fontSize: "11px", fontWeight: "700" }}>Starting 7 Starts</span>
                                  <h3 className="font-weight-bold text-warning my-1">
                                    {playTimeData?.overall?.startingAppearances || 0}
                                  </h3>
                                  <span className="text-muted" style={{ fontSize: "12px" }}>
                                    Out of {playTimeData?.overall?.matchesCount || 0} games
                                  </span>
                                </div>
                              </div>
                              <div className="col-lg-3 col-sm-6 mb-3">
                                <div className="card border-0 shadow-sm text-center p-3" style={{ background: "#f8fafc", borderLeft: "4px solid #64748b" }}>
                                  <span className="text-muted text-uppercase" style={{ fontSize: "11px", fontWeight: "700" }}>Impact Sub Appearances</span>
                                  <h3 className="font-weight-bold text-dark my-1">
                                    {playTimeData?.overall?.subAppearances || 0}
                                  </h3>
                                  <span className="text-muted" style={{ fontSize: "12px" }}>
                                    Substituted onto court
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* PER MATCH BREAKDOWN TABLE */}
                            <h6 className="main-content-label mb-3">📋 Play Time per Match</h6>
                            <div className="table-responsive mb-4">
                              <table className="table table-bordered table-hover">
                                <thead className="thead-light">
                                  <tr>
                                    <th>#</th>
                                    <th>Match Title</th>
                                    <th>Date</th>
                                    <th>Team</th>
                                    <th>Starting 7?</th>
                                    <th>Subs</th>
                                    <th>Play Time</th>
                                    <th>% of Game</th>
                                    <th>Calculation Formula</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(playTimeData?.byMatch || []).length === 0 ? (
                                    <tr>
                                      <td colSpan="9" className="text-center py-4 text-muted">
                                        No match play time recorded for this player yet.
                                      </td>
                                    </tr>
                                  ) : (
                                    playTimeData.byMatch.map((bm, idx) => (
                                      <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        <td><strong>{bm.matchTitle}</strong></td>
                                        <td>{bm.matchDate ? new Date(bm.matchDate).toLocaleDateString() : "N/A"}</td>
                                        <td><span className="badge badge-light">{bm.teamName}</span></td>
                                        <td>
                                          <span className={`badge ${bm.startingPlayer ? "badge-success" : "badge-secondary"}`}>
                                            {bm.startingPlayer ? `Yes (${bm.startingPosition || "Court"})` : "Bench Sub"}
                                          </span>
                                        </td>
                                        <td>{bm.substitutionsCount}</td>
                                        <td><strong className="text-success">{bm.formatted || `${bm.minutes}m`}</strong></td>
                                        <td>
                                          <div className="progress" style={{ height: "6px", width: "70px", display: "inline-block", verticalAlign: "middle", marginRight: "6px" }}>
                                            <div className="progress-bar bg-success" style={{ width: `${Math.min(100, bm.percentageOfMatch || 0)}%` }} />
                                          </div>
                                          <span style={{ fontSize: "11px" }}>{bm.percentageOfMatch}%</span>
                                        </td>
                                        <td style={{ fontSize: "11px", color: "#64748b", maxWidth: "250px" }}>{bm.formula}</td>
                                      </tr>
                                    ))
                                  )}
                                </tbody>
                              </table>
                            </div>

                            {/* PER TEAM BREAKDOWN TABLE */}
                            <h6 className="main-content-label mb-3">🛡️ Play Time per Team</h6>
                            <div className="table-responsive mb-4">
                              <table className="table table-bordered table-hover">
                                <thead className="thead-light">
                                  <tr>
                                    <th>#</th>
                                    <th>Team Name</th>
                                    <th>Matches</th>
                                    <th>Total Play Time</th>
                                    <th>Avg per Match</th>
                                    <th>Starting 7 Starts</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(playTimeData?.byTeam || []).length === 0 ? (
                                    <tr>
                                      <td colSpan="6" className="text-center py-4 text-muted">
                                        No team records available.
                                      </td>
                                    </tr>
                                  ) : (
                                    playTimeData.byTeam.map((bt, idx) => (
                                      <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        <td><strong>{bt.teamName}</strong></td>
                                        <td>{bt.matchesCount} match(es)</td>
                                        <td><strong className="text-primary">{bt.formatted || `${bt.totalMinutes}m`}</strong></td>
                                        <td>{bt.avgMinutesPerMatch} min / match</td>
                                        <td><span className="badge badge-success">{bt.startingAppearances} start(s)</span></td>
                                      </tr>
                                    ))
                                  )}
                                </tbody>
                              </table>
                            </div>

                            {playTimeData?.formula && (
                              <div className="alert alert-primary mb-4" role="alert" style={{ fontSize: "13px" }}>
                                <strong>📐 Overall Cumulative Formula:</strong> {playTimeData.formula}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}

                    <div className="mt-5">
                      <button
                        className="btn ripple btn-dark"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewPlayers;